import goods from "@/api/goods/url.js"; //商品管理模块接口url
import system from "@/api/system/url.js"; //系统管理模块接口url
import permit from "@/api/permit/url.js"; //物流模块接口url
import template from "@/api/template/url.js"; //模板接口
import business from "@/api/business/url.js";
import coupon from "@/api/couponactivities/url.js";
import member from "@/api/member/url.js";
import category from '@/api/category/url.js';
import shoppingguide from '@/api/shoppingguide/url.js';
import brand from '@/api/brand/url.js';
import market from '@/api/marketing/url.js';
import deal from '@/api/deal/url.js';
import settleAccounts from '@/api/settleAccounts/url.js';
import card from '@/api/card/url.js';
import home from '@/api/home/url.js';
import renovation from '@/api/renovation/url.js';
import content from '@/api/content/url.js'
import column from '@/api/column/url.js';
import count from '@/api/count/url.js';
import homeDialog from '@/api/homeDialog/url.js';
import merchant from '@/api/merchant/url.js';
import liveBroadcast from '@/api/liveBroadcast/url.js';
import newMarketing from '@/api/newMarketing/url.js';
import smartScreen from '@/api/smartScreen/url.js';
import starsCash from '@/api/starsCash/url.js';
import matterManage from '@/api/matterManage/url.js'
import retailStore from '@/api/retailStore/url.js'
import channerAdmin from '@/api/channerAdmin/url.js'
let apiUrl = {
    ...goods.apiUrl,
    ...system.apiUrl,
    ...permit.apiUrl,
    ...template.apiUrl,
    ...business.apiUrl,
    ...member.apiUrl,
    ...coupon.apiUrl,
    ...category,
    ...brand,
    ...market,
    ...card,
    ...settleAccounts,
    ...deal,
    ...home,
    ...shoppingguide.apiUrl,
    ...renovation,
    ...content,
    ...column,
    ...count,
    ...homeDialog,
    ...merchant,
    ...liveBroadcast,
    ...starsCash,
    ...smartScreen,
    ...newMarketing,
    ...matterManage,
    ...retailStore,
    ...channerAdmin
}
export default apiUrl;
